
namespace TabAurous.HR {

    @Serenity.Decorators.panel()
    @Serenity.Decorators.registerClass()
    export class PayrollDialog extends _Ext.DialogBase<PayrollRow, any> {
        protected getFormKey() { return PayrollForm.formKey; }
        protected getIdProperty() { return PayrollRow.idProperty; }
        protected getLocalTextPrefix() { return PayrollRow.localTextPrefix; }
        protected getNameProperty() { return PayrollRow.nameProperty; }
        protected getService() { return PayrollService.baseUrl; }
        protected getDeletePermission() { return PayrollRow.deletePermission; }
        protected getInsertPermission() { return PayrollRow.insertPermission; }
        protected getUpdatePermission() { return PayrollRow.updatePermission; }

        public form = new PayrollForm(this.idPrefix);
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 290;
            q.initDetailEditor(this, this.form.Details, Config);
            q.SetCategoryEightColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.CurrencyId);
            q.SetCategoryFullWidth(this.form.Details);

            q.setTextRightAlign(this.form.ExchRate);

            q.hideCategorylinks(this.element);
            q.HideCategoryLable(this.element);
            q.hideEditorLabel(this.form.Details);
        }
    }
}